import React, { useState } from "react";
import AsyncSelect from "react-select/async";
import { components } from "react-select";
import { debounce } from "lodash";
import { EuiCheckbox } from "@elastic/eui";
import styled from "styled-components";
import { StyledLabel, InputGroup, StyledRequired, Error, Hint } from "./styles";
import Button from "./button";

const ErrorMessage = styled.p`
    color: #bd271e;
    font-weight: 400;
    font-size: 12px;
    margin-top: 4px;
`;
const ErrorLabel = styled(StyledLabel)`
    color: #bd271e;
`;
export const customStyles = {
    container: (provided, state) => {
        const background = state.isDisabled ? "#9a9c9f57" : "";
        const color = state.isDisabled ? "#fff" : "hsl(0,0%,20%)";
        return {
            ...provided,
            background,
            color,
            width: "100%",
            position: "relative",
            border: "1px solid #c0c1c2",
            borderRadius: "4px",
            padding: ".5px 4px",
        };
    },
    option: (provided, state) => ({
        ...provided,
        borderBottom: "1px solid cayan",
        color: state.isSelected ? "#198AA5" : "#111827",
        display: "block",
        height: 35,
        width: "100%",
        padding: "2px 20px",
        background: "#fff",
        border: "none",
        outline: "none",
        fontSize: "1rem",
        textAlign: "left",
        cursor: "pointer",
        fontWeight: state.isSelected ? "600" : "500",
        paddingBottom: "0",
        marginBottom: "0",
        whiteSpace: "nowrap",
    }),
    control: () => ({
        display: "flex",
        flexDirection: "row",
        flex: 1,
        alignItems: "center",
        justifyContent: "space-between",
    }),
    placeholder: (base, state) => {
        return {
            ...base,
            display: !state.isFocused ? "default" : "none",
        };
    },
    menu: () => ({
        position: "absolute",
        width: "100%",
        minWidth: "fit-content",
        zIndex: 2,
        boxShadow: "0px 0px 1px 0px rgba(0, 0, 0,0.5)",
        paddingTop: "2px",
        borderRadius: "6px",
        display: "block",
        top: "48px",
        right: "0",
        background: "#fff",
        fontSize: "1rem",
    }),
    menuList: (provided) => ({
        ...provided,
        paddingBottom: "10px",
        borderRadius: "6px",
    }),
    indicatorSeparator: () => ({
        background: "transparent",
    }),
    singleValue: (provided) => {
        return {
            ...provided,
            fontSize: "1rem",
            color: "#111827",
            fontWeight: "600",
        };
    },
    clearIndicator: (provided) => ({
        ...provided,
        fontSize: "0.875rem",
    }),
    valueContainer: (provided, state) => {
        const color = state.isDisabled ? "#fff" : "hsl(0,0%,20%)";
        return {
            ...provided,
            color,
            padding: "2px 0",
            display: "flex",
            flexWrap: "nowrap",
            alignItems: "center",
            fontSize: "1rem",
        };
    },
};
export const notEditableStyle = {
    valueContainer: () => ({
        padding: "2px 0",
        display: "flex",
        flexWrap: "wrap",
        color: "hsl(0,0%,20%)",
    }),
    option: (provided, state) => ({
        ...provided,
        borderBottom: "1px solid cayan",
        color: state.isSelected ? "#198AA5" : "#111827",
        display: "block",
        height: 35,
        width: "100%",
        padding: "2px 20px",
        background: "#fff",
        border: "none",
        outline: "none",
        fontSize: "1rem",
        textAlign: "left",
        cursor: "pointer",
        fontWeight: state.isSelected ? "600" : "500",
        paddingBottom: "0",
        marginBottom: "0",
    }),
    control: () => ({
        display: "flex",
        flexDirection: "row",
        flex: 1,
    }),
    placeholder: (base, state) => ({
        ...base,
        display: !state.isFocused ? "default" : "none",
    }),
    menu: () => ({
        position: "absolute",
        width: "100%",
        zIndex: 2,
        boxShadow: "0px 0px 1px 0px rgba(0, 0, 0,0.5)",
        paddingTop: "2px",
        borderRadius: "6px",
        display: "block",
        top: "42px",
        background: "#fff",
    }),
    menuList: (provided) => ({
        ...provided,
        paddingBottom: "10px",
        borderRadius: "6px",
    }),
    indicatorSeparator: () => ({
        background: "transparent",
    }),
    indicatorsContainer: () => ({
        display: "none",
    }),
    singleValue: (provided) => ({
        ...provided,
        fontSize: "16px",
        color: "#171717",
        fontWeight: "400",
    }),
    clearIndicator: (provided) => ({
        ...provided,
        fontSize: "0.875rem",
    }),
    multiValue: () => ({
        backgroundColor: "transparent",
    }),
    multiValueRemove: () => ({
        display: "none",
    }),
    multiValueLabel: () => ({
        padding: 0,
        marginRight: "17px",
        fontSize: "16px",
    }),
};
export default function SelectWithSearch({
    options,
    handleFilter,
    handleChange,
    placeholder,
    value,
    name,
    style,
    customMenuBtn,
    handleCustomBtnOnClick,
    label,
    required,
    isMulti,
    error,
    isEditable,
    disable,
    errorMsg,
    errorMessage,
    customBtns,
    closeMenuOnSelect,
    onMenuClose,
}) {
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const Menu = (props) => {
        return (
            <components.Menu {...props}>
                <div>
                    {props.selectProps.fetchingData ? (
                        <span className="fetching">Fetching data...</span>
                    ) : (
                        <div>{props.children}</div>
                    )}
                    {customMenuBtn?.name && (
                        <Button
                            // classes={
                            //     'flex bg-white border-t-2 border-gray-100 py-[8px] w-full shadow-md rounded-b-md my-0 font-inter text-[14px] font-medium text-[#198AA5] justify-center'
                            // }
                            btnStyle={"primaryBtn"}
                            name={customMenuBtn?.name}
                            onClick={handleCustomBtnOnClick}
                        >
                            {customMenuBtn?.name}
                        </Button>
                    )}
                    {customBtns && customBtns}
                </div>
            </components.Menu>
        );
    };

    const Option = (props) => {
        if (isMulti) {
            return (
                <>
                    <components.Option {...props}>
                        <EuiCheckbox
                            label={props.children}
                            checked={props.isSelected}
                        />
                    </components.Option>
                </>
            );
        } else {
            return <components.Option {...props}>{props.children}</components.Option>;
        }
    };

    const _loadOptions = async (inputValue, callback) => {
        callback(await handleFilter(inputValue));
    };

    const loadOptionsDebounced = debounce(_loadOptions, 1000);

    const loadOption = (inputValue, callback) => {
        if (inputValue.length < 2 || inputValue.endsWith(" ")) {
            return;
        }
        loadOptionsDebounced(inputValue, callback);
    };

    const handleOnChange = (value, name) => {
        handleChange(value, name);
    };

    return (
        <>
            <InputGroup>
                {errorMessage ? (
                    <ErrorLabel>
                        {label} {required && <StyledRequired>*</StyledRequired>}
                    </ErrorLabel>
                ) : label ? (
                    <StyledLabel>
                        {label} {required && <StyledRequired>*</StyledRequired>}
                    </StyledLabel>
                ) : null}
                <AsyncSelect
                    name={name}
                    value={value || undefined}
                    styles={isEditable ? (style ? style : customStyles) : notEditableStyle}
                    loadOptions={loadOption}
                    defaultOptions={options}
                    onChange={(value) => handleOnChange(value, name)}
                    isClearable
                    placeholder={placeholder}
                    backspaceRemovesValue
                    loadingMessage={() => "loading"}
                    maxMenuHeight={150}
                    controlShouldRenderValue
                    components={{ Menu, Option }}
                    menuIsOpen={menuIsOpen}
                    onMenuOpen={() => {
                        setMenuIsOpen(true);
                    }}
                    onMenuClose={() => {
                        //this handle the firing event inside custom menu for mobile view
                        handleCustomBtnOnClick
                            ? setTimeout(() => {
                                  setMenuIsOpen(false);
                              }, 500)
                            : setMenuIsOpen(false);
                        onMenuClose && onMenuClose();
                    }}
                    isDisabled={!isEditable || disable}
                    isMulti={isMulti}
                    closeMenuOnSelect={closeMenuOnSelect ? !closeMenuOnSelect : !isMulti}
                    hideSelectedOptions={false}
                    errorMessage={errorMessage}
                />
                {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
                <Hint>
                    {error && required && (
                        <Error>{errorMsg ? errorMsg : "please fill this field"}</Error>
                    )}
                </Hint>
            </InputGroup>
        </>
    );
}
